import * as React from "react";
import {Grid, Icon, Label} from "semantic-ui-react";

import {useState, useEffect, useRef} from "react";
import styled from "styled-components";

import visa from "../../resources/images/payment/visa.png";
import mc from "../../resources/images/payment/mc.png";
import ms from "../../resources/images/payment/ms.png";
import sp from "../../resources/images/payment/secured-by-sage-pay.png";
import sagepay from "../../resources/images/payment/logo_secured-by-sage-pay.png";
import lock from "../../resources/images/payment/lock.png";
import * as LuhnUtils from "../../utils/validation/luhn"

import _ from 'lodash';
import {bool} from "prop-types";

interface ICreditCardInputProps {
    onValid(
        valid: boolean,
        number: string,
        cvc: string,
        month: string,
        year: string,
        name: string,
        issuer: string
    ): void;

    focus: boolean;
    loading: boolean;
    success?: boolean;

    onClick(): void;

    onCancel(): void;

    amount: number;
    error?: string;
    showCancelButton?: boolean;
    hideCreditCardDetailsAndPayment?: boolean;
    containerTitle?: string;
}

export const CreditCardInput: React.FC<ICreditCardInputProps> = ({
                                                                     onValid,
                                                                     focus,
                                                                     loading,
                                                                     success,
                                                                     onClick,
                                                                     onCancel,
                                                                     amount,
                                                                     error,
                                                                     showCancelButton,
                                                                     hideCreditCardDetailsAndPayment,
                                                                     containerTitle
                                                                 }) => {

    const visaPattern = /^(4[0-9]{3})/;
    const ukePattern = /^(4917|4026|417500|4508|4844|4913)/;
    const deltaPattern = /^(4462)/;
    const mcPattern = /^(5[1-5][0-9]{2}|2[2-7][0-9]{2})/;
    const maestroPattern = /^(5[0,6-8][0-9]{2}|63[0-9]|67[0-9]{2})/;



    const visaLogoPattern = new RegExp(
        visaPattern.source + "|" + ukePattern.source + "|" + deltaPattern.source
    );

    const mcLogoPattern = mcPattern;
    const msLogoPattern = maestroPattern;
    const cardPattern = new RegExp(
        "^(" +
        visaPattern.source +
        "|" +
        ukePattern.source +
        "|" +
        deltaPattern.source +
        "|" +
        mcPattern.source +
        "|" +
        maestroPattern.source +
        ")" +
        " [0-9]{4} [0-9]{4} [0-9]{1,4}\s?$"
    ); //^(^(4[0-9]{3})|^(4917|4026|417500|4508|4844|4913)|^(4462)|^(5[1-5][0-9]{2}|2[2-7][0-9]{2})|^(5[0,6-8][0-9]{2}|63[0-9]|67[0-9]{2})) [0-9]{4} [0-9]{4} [0-9]{1,4}\s?$ 

    const alphaInputPattern = /^[a-zA-Z '-]*$/;
    const numericInputPattern = /^[0-9]*$/;

    const [s, setCreditCardInfo] = useState({
        number: "",
        cvc: "",
        month: "",
        year: "",
        name: "",
        issuer: "",
    });
    const [issuer, setIssuer] = useState("");
    const [isV, setIsValid] = useState(false);
    const [{}, setFocus] = useState(false);
    const nameRef = useRef<HTMLInputElement>(null);
    const monthRef = useRef<HTMLInputElement>(null);
    const yearRef = useRef<HTMLInputElement>(null);
    const cvcRef = useRef<HTMLInputElement>(null);
    const [logo, setLogo] = useState("");
    const [errorMessage, setErrorMessage] = useState<string | null>(error || null);
    const [displayCancelButton, setDisplayCancelButton] = useState<boolean | null>(showCancelButton || null);
    const [containerTitleText, setContainerTitleText] = useState<string | null>(containerTitle || null);
    const [hiddenCreditCardDetailsAndPayment, setHiddenCreditCardDetailsAndPayment] = useState<boolean | null>(hideCreditCardDetailsAndPayment || null);

    useEffect(() => {
        if (nameRef.current && focus) {
            nameRef.current.focus();
        }
    }, [nameRef]);

    useEffect(() => {
        const cardMatch = s.number.match(cardPattern);
        if (cardMatch && cardMatch.length > 0)
        {
            console.log("Valid " + cardMatch.length);
        }
        const valid =
            s.name != "" &&
            s.cvc.length == 3 &&
            s.month.length == 2 &&
            s.year.length == 2 &&
            ((cardMatch && cardMatch.length > 0) || false);

        let validLuhn = false;
        if (valid) {
            var cleanCreditCardNumber = LuhnUtils.cleanProposed(s.number);
            validLuhn = LuhnUtils.isLuhnValid(cleanCreditCardNumber);
        }

        setIsValid(valid && validLuhn);
        onValid(valid && validLuhn, s.number, s.cvc, s.month, s.year, s.name, issuer);
    }, [s]);

    useEffect(() => {
        console.log(error)
        if (error) {
            setErrorMessage(error)
        } else {
            setErrorMessage(null);
        }
    }, [error])

    useEffect(() => {
        console.log(showCancelButton)
        if (showCancelButton) {
            setDisplayCancelButton(showCancelButton)
        } else {
            setDisplayCancelButton(null);
        }
    }, [showCancelButton])

    useEffect(() => {
        console.log(hideCreditCardDetailsAndPayment)
        if (hideCreditCardDetailsAndPayment) {
            setHiddenCreditCardDetailsAndPayment(hideCreditCardDetailsAndPayment)
        } else {
            setHiddenCreditCardDetailsAndPayment(null);
        }
    }, [hideCreditCardDetailsAndPayment])


    const pay = (_: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        console.log('Calling payment handler');
        //setErrorMessage(null); 
        onClick();
    };

    const cancel = (_: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        console.log('Calling cancel handler');
        onCancel();
    };

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (
            e.target.name == "month" ||
            e.target.name == "year" ||
            e.target.name == "cvc"
        ) {
            const numMatch =
                e.target.name == "cvc"
                    ? e.target.value.match(/^\d{0,3}$/)
                    : e.target.value.match(/^\d{0,2}$/);
            const dateMatch = e.target.value.match(e.target.pattern);

            if (!numMatch) {
                return;
            }
            if (!dateMatch && e.target.value.length == 2 && e.target.name != "cvc") {
                return;
            }
            if (e.target.name == "year" && e.target.value.length == 2) {

                console.log(`Expiry date validation - ${s.month}, ${e.target.value}`)

                if (parseInt(e.target.value) + 2000 == new Date().getUTCFullYear() && parseInt(s.month) < (new Date().getMonth() + 1)) {
                    console.log(`Expiry date validation fails - ${s.month}, ${e.target.value}`)
                    return;
                }
                if (parseInt(e.target.value) + 2000 < new Date().getUTCFullYear()) {
                    console.log(`Expiry date validation fails for year - ${s.month}, ${e.target.value}`)
                    return;
                }
            }
            if (
                e.target.name == "month" &&
                e.target.value.length == 2 &&
                yearRef.current != null
            ) {
                yearRef.current.value = "";
                if (s.year != "" && s.year != null) {
                    setCreditCardInfo({...s, year: "", month: e.target.value});
                    yearRef.current.focus();
                    return;
                }
                yearRef.current.focus();
            }
            if (
                e.target.name == "year" &&
                e.target.value.length == 2 &&
                cvcRef.current != null
            ) {
                cvcRef.current.focus();
            }
        }
        let number = s.number;
        if (e.target.name == "number" && e.target.value.length > s.number.length) {
            const parts = e.target.value
                .replace(/\s+/, "")
                .trim()
                .split("");
            let str = "";
            parts
                .filter((p) => p != " ")
                .forEach((p, i) => {
                    str = str + p;
                    if ((i + 1) % 4 == 0) {
                        str = str + " ";
                    }
                });
            number = str.trim();
        } else if (e.target.name == "number") {
            number = e.target.value.trim();
        }

        if (e.target.name == "name" && e.target.value.length > 1) {
            const fullName = e.target.value;
            if (fullName.length > 0) {
                if (fullName.indexOf(" ") > -1) {
                    const nameParts = fullName.split(" ");
                    for (let i = 0; i < nameParts.length; i++) {
                        if (nameParts[i].trim().length > 0) {
                            nameParts[i] = nameParts[i][0].toUpperCase() + nameParts[i].substr(1).toLowerCase();
                        }
                    }
                    setCreditCardInfo({...s, name: nameParts.join(" ")});
                } else {
                    const fullNameInitialCaps = fullName[0].toUpperCase() + fullName.substr(1).toLowerCase();
                    setCreditCardInfo({...s, name: fullNameInitialCaps});
                }
            }
        } else {
            setCreditCardInfo({...s, [e.target.name]: e.target.value, number});
        }
        if (s.number.match(visaLogoPattern)) {
            setLogo("card-logo-visa");
            setIssuer("VISA");
        }
        if (s.number.match(mcLogoPattern)) {
            setLogo("card-logo-mc");
            setIssuer("MASTERCARD");
        }
        if (s.number.match(deltaPattern)) {
            setIssuer("DELTA");
        }
    };

    const handleKeyPress = (e) => {
        if (!alphaInputPattern.test(e.key)) {
            e.preventDefault();
        }
    };


    const handleNumericKeyPress = (e) => {
        if (!numericInputPattern.test(e.key)) {
            e.preventDefault();
        }
    };


    return (
        <>
            <CreditCardContainer>
                <section id="payment-details-container">
                    {!hiddenCreditCardDetailsAndPayment &&
                        <div className="container">
                            <div className="row">
                                <div className="container-title">
                                    {containerTitleText ? containerTitleText : "Please enter your card details"}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="payment-details-label">Card name</Label>
                                <input
                                    name="name"
                                    required
                                    maxLength={32}
                                    ref={nameRef}
                                    onChange={handleOnChange}
                                    onKeyPress={handleKeyPress}
                                    autoComplete="cc-name"
                                    value={s.name}
                                    placeholder="Name as it appears on the front of the card"
                                />
                            </div>
                            <div className="row">
                                <Label className="payment-details-label">Card number</Label>
                                <input
                                    name="number"
                                    type="tel"
                                    required
                                    autoComplete="cc-number"
                                    inputMode='numeric'
                                    pattern="[0-9\s]{13,19}"
                                    placeholder="XXXX XXXX XXXX XXXX"
                                    maxLength={19}
                                    onChange={handleOnChange}
                                    onKeyPress={handleNumericKeyPress}
                                    value={s.number}
                                    className={logo}
                                />
                            </div>
                            <div className="row">
                                <div className="column-one">
                                    <Label className="payment-details-label">Expires</Label>
                                    <input
                                        className="short no-wrap payment-details-expires-month"
                                        name="month"
                                        type="tel"
                                        ref={monthRef}
                                        required
                                        pattern="^(0[1-9]|10|11|12)$"
                                        autoComplete="cc-exp-month"
                                        inputMode='numeric'
                                        placeholder="MM"
                                        maxLength={2}
                                        onChange={handleOnChange}
                                        onKeyPress={handleNumericKeyPress}
                                        value={s.month}
                                    />
                                    <input
                                        className="short no-wrap payment-details-expires-year"
                                        name="year"
                                        type="tel"
                                        ref={yearRef}
                                        required
                                        pattern="^[0-9]{2}$"
                                        inputMode='numeric'
                                        autoComplete="cc-exp-year"
                                        placeholder="YY"
                                        maxLength={2}
                                        onChange={handleOnChange}
                                        onKeyPress={handleNumericKeyPress}
                                        value={s.year}
                                    />
                                </div>
                                <div className="column-two">
                                    <Label className="payment-details-label">CVC/CCV</Label>
                                    <input
                                        className="short payment-details-cvc"
                                        type="tel"
                                        name="cvc"
                                        ref={cvcRef}
                                        required
                                        pattern="[0-9]{3}"
                                        inputMode='numeric'
                                        placeholder="XXX"
                                        autoComplete="cc-csc"
                                        maxLength={3}
                                        onChange={handleOnChange}
                                        onKeyPress={handleNumericKeyPress}
                                        value={s.cvc}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {errorMessage &&
                        <div className="row">
                            <span className="payment-error">{errorMessage}</span>
                        </div>}
                    <div className="row">
                        {!loading && !success && amount && !hiddenCreditCardDetailsAndPayment && (
                            <button
                                className={`purchase stage-10`}
                                type="button"
                                disabled={!isV}
                                onClick={_.debounce(pay, 1000, {
                                    'leading': true,
                                    'trailing': false
                                })}
                            >
                                <span id="lock"></span>Pay £{amount.toFixed(2)}
                            </button>)}
                        {!loading && !success && amount && displayCancelButton && (
                            <button
                                className={`cancel stage-10`}
                                type="button"
                                onClick={_.debounce(cancel, 1000, {
                                    'leading': true,
                                    'trailing': false
                                })}
                            >
                                Cancel
                            </button>
                        )}
                        {loading && (
                            <button className={`purchase stage-10`} type="button" disabled>
                                <span id="lock"></span>
                                <Icon name={"spinner"} loading/>
                            </button>
                        )}
                        {!loading && (success || false) && (
                            <button className={`purchase stage-10`} type="button" disabled>
                                <span id="lock"></span>
                                <Icon name={"check"}/>
                            </button>
                        )}
                    </div>
                    <div className="row">
                        <div id="card-logos">
                            <div className="card-logo-sp"></div>
                            <div className="card-logo-visa"></div>
                            <div className="card-logo-mc"></div>
                        </div>
                    </div>

                </section>
            </CreditCardContainer>
        </>
    );
};

const CreditCardContainer = styled.div`
    #payment-details-container {
        margin: 0 auto;
        font-family: "FigTree-Standard", sans-serif !important;
    }

    .container {
        border: 4px solid #dae2e8;
        padding-top: 12px;
        color: rgb(16, 63, 111);

        .container-title {
            text-align: left;
            font-size: 17px;
        }
    }

    .row {
        text-align: left;
        padding: 0px 0px 8px 0px;
        box-sizing: border-box;
        display: block !important;
        margin: 0 !important;

        .column-one {
            display: inline-block;
            width: 50%;
        }

        .column-two {
            display: inline-block;
            width: 50%;
        }
    }

    .payment-details-label {
        font-family: "FigTree-Medium", sans-serif !important;
        background: none;
        -webkit-text-decoration: none;
        text-decoration: none;
        font-weight: normal;
        display: block;
        padding-left: 0;
        color: rgb(16, 63, 111);
        font-size: 15px;
    }

    input {
        padding: 10px;
        margin: 0;
        border: 1px solid rgba(34, 36, 38, 0.15);
        width: 100%;
        border-radius: 5px;

        &[name="expyy"] {
            margin-right: 20px;
        }

        &.short {
            width: 65px !important;
            margin-right: 10px;

            @media (min-width: 350px) {
                width: 50px !important;
                margin-right: 5px;
            }
        }

        &.payment-details-expires-month {
            margin-right: 8px !important;
        }
    }

    input[name="number"] {
        background-position: right 5px center;
        background-repeat: no-repeat;
        background-size: auto 30px;
    }

    button {
        background-color: #21ba45;
        color: #fff;
        width: 100%;
        padding: 12px 20px;
        font-size: 16px;
        cursor: pointer;
        display: inline-block;
        min-height: 1em;
        outline: 0;
        border: none;
        vertical-align: baseline;

        &[disabled] {
            opacity: 0.5;
            cursor: default;
        }
    }

    button.purchase {
        margin-bottom: 8px;
    }

    button.cancel {
        background-color: #e0e0e0;
        color: #000;
    }

    #card-logos {
        text-align: center;

        > div {
            width: 56px;
            height: 36px;
            margin: 0 5px;
            display: inline-block;
            background-position: center;
            background-repeat: no-repeat;
            background-size: auto 30px;
            padding: 3px;
            background-color: #fff;
        }
    }

    .card-logo-visa {
        background-image: url(${visa});
    }

    .card-logo-mc {
        background-image: url(${mc});
    }

    .card-logo-sp {
        background-image: url(${sp});
    }

    .payment-error {
        color: red;
        font-weight: bold;
        display: inline-block;
        text-align: center;
        padding-bottom: 4px;
    }
`; 
